import React, { type HTMLAttributes } from 'react';

import Immutable from 'immutable';

import type {
  NodeEntity,
  GenericField,
  ImmutableEntity,
  OptionalArrayField,
} from '@uncinc/react-drupal-core/types';
import { Paragraph } from '@uncinc/react-drupal-core';
import { Container, WysiwygField } from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

interface GenericBasicPageProps extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableEntity<NodeEntity & {
    body: OptionalArrayField<[GenericField<string>]>,
    field_paragraphs: OptionalArrayField<[any]>,
  }>;
}

const GenericBasicPage = ({ entity }: GenericBasicPageProps) => {
  const page = entity.toJS();
  const title = page.title[0].value;
  const body = page.body[0]?.value ?? '';
  const paragraphs = page.field_paragraphs ?? [];

  return (
    <div className="GenericBasicPage">
      <Container>
        <div className="row">
          <div className="col-12 col-md-10 offset-md-1 col-lg-8 offset-lg-2">
            <div className="GenericBasicPage__title">
              <h1>{title}</h1>
            </div>
            {body && (
              <WysiwygField property="schema:text" html={body} className="GenericBasicPage__body" />
            )}
          </div>
        </div>
        {paragraphs.length > 0 && (
          <div className="GenericBasicPage__paragraphs">
            {paragraphs.map((item) => {
              const paragraph = item.entity;
              const paragraphId = item.target_id;
              return (
                <Paragraph
                  key={paragraphId}
                  entity={Immutable.fromJS(paragraph)}
                  id={paragraphId}
                />
              );
            })}
          </div>
        )}
      </Container>
    </div>
  );
};

export default GenericBasicPage;
